import {
  CREATE_ADMIN_ACCOUNT_REQUEST,
  CREATE_ADMIN_ACCOUNT_SUCCESS,
  CREATE_ADMIN_ACCOUNT_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  error: null,
};

const createAdminAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ADMIN_ACCOUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_ADMIN_ACCOUNT_SUCCESS:
      return { ...state, loading: false, error: null };
    case CREATE_ADMIN_ACCOUNT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default createAdminAccountReducer;
